import { colonyAPI } from '@/api';
import * as types from './mutation-types';

export default {
  getCompany({ commit }) {
    commit(types.GET_COMPANY_REQUEST);
    colonyAPI
      .get('accounts/companies/active/')
      .then(response => commit(types.GET_COMPANY_SUCCESS, response))
      .catch(error => commit(types.GET_COMPANY_FAILURE, error));
  },

  updateCompany({ commit }, company) {
    commit(types.UPDATE_COMPANY_REQUEST);
    colonyAPI
      .put(`accounts/companies/${company.id}/`, company)
      .then(response => commit(types.UPDATE_COMPANY_SUCCESS, response))
      .catch(error => commit(types.UPDATE_COMPANY_FAILURE, error));
  },

  getCompanies({ commit }) {
    commit(types.GET_COMPANIES_REQUEST);
    colonyAPI
      .get('accounts/companies/')
      .then(response => commit(types.GET_COMPANIES_SUCCESS, response))
      .catch(error => commit(types.GET_COMPANIES_FAILURE, error));
  },

  getTimezones({ commit }) {
    commit(types.GET_TIMEZONES_REQUEST);
    colonyAPI
      .get('accounts/timezones/')
      .then(response => commit(types.GET_TIMEZONES_SUCCESS, response))
      .catch(error => commit(types.GET_TIMEZONES_FAILURE, error));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/company/actions.js